import jsPDF from "jspdf";
import html2canvas from "html2canvas";

/** 20 for a4 js, 25 for a5  */
export var PrintMyContent = function(myIframe,onDone=new Function(),type=20,printScale=2,maxPageTo=999999999,title=''){
    var child = myIframe.contentWindow.document.children[0];
    var allPages = [] ;
    var childContainer = child.children[1].children[0].children[0] ;
    while(childContainer.children.length>0){
        allPages.push(childContainer.removeChild(childContainer.children[0]));
    }

    var pdf = new jsPDF("p", "cm", type===20?"a4":"a5");

    myIframe.style.width = pdf.internal.pageSize.width+"cm";
    myIframe.style.height = pdf.internal.pageSize.height+"cm";
    // myIframe.style.opacity = "0";

    var pageWidth_cm = pdf.internal.pageSize.width * printScale;
    var pageHeight_cm = pdf.internal.pageSize.height * printScale;
    var pageWidth_px = pageWidth_cm * 37.7952755906;
    var pageHeight_px = pageHeight_cm * 37.7952755906;
    var totalPages = Math.min(maxPageTo,allPages.length);
    const pagePerRender = 10 ;
    // const child_len = pages.length;

    // debugger;
    if(totalPages==0){
        alert('هیچ رکوردی برای پرینت وجود ندارد');
        onDone();
        return;
    }
    ConvertPagesFromTo(0,Math.min(totalPages,0+pagePerRender));

    function ConvertPagesFromTo(from,to){
        // debugger;
        if(from >= totalPages){
            pdf.save(title);
            onDone();
            return;
        }

        while(childContainer.children.length>0){
            childContainer.removeChild(childContainer.children[0]);
        }

        // debugger;

        allPages.slice(from,to).forEach((item)=>{
            childContainer.appendChild(item);
        });

        html2canvas(child, {
            foreignObjectRendering: false,
            scale: printScale,
            allowTaint:true,
            useCORS:true,
        }).then(canvas => {
                var ctx = canvas.getContext('2d');
                var ImageData = ctx.getImageData(0, 0, pageWidth_px, pageHeight_px * (to-from));
                var canvasRenderer = document.createElement('canvas');
                var ctx2 = canvasRenderer.getContext('2d');
                canvasRenderer.width = pageWidth_px;
                canvasRenderer.height = pageHeight_px;
                for( var i = from ; i < to ; i++){
                    if(i !== 0){
                        pdf.addPage();
                    }
                    console.log("PDF Page: "+(i+1))
                    ctx2.putImageData(ImageData, 0, -1 * (i-from) * pageHeight_px);
                    pdf.setPage(i+1);//1 index
                    pdf.addImage(canvasRenderer, 'JPEG', 0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, null, "FAST");
                }

                // debugger;
                ConvertPagesFromTo(to,Math.min(totalPages,to+pagePerRender));
        });
    }
}